export default {
    findRoles:      { method: 'get', url: 'roles?with=menus'},
    createRole:     { method: 'post', url: 'roles'},
    updateRole:     { method: 'put', url: 'roles/{id}'},
    updateRoleMenu: { method: 'put', url: 'roles/menu/{id}'},
    instances:      { method: 'get', url: 'instances?column_order=name'},
    charts:         { method: 'get', url: 'roles/charts' },
    index:          { method: 'get', url: 'roles'},
    destroyRole:    { method: 'delete', url: 'roles/{id}'}
}